// extracted by mini-css-extract-plugin
export default {"root":"NotificationDetail_root__ROpl8","body":"NotificationDetail_body__ND2ui"};